import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-redirect-to-form-editor',
    template: '',
    standalone: true
})
export class RedirectToFormEditorComponent implements OnInit {

    constructor(private route: ActivatedRoute, private router: Router) { }

    ngOnInit(): void {
        const queryParams = this.route.snapshot.queryParams
        this.router.navigate(['/form-builder'], { queryParams })
    }

}
